export default "__VITE_ASSET__CYRs3oj5__"